import axios from 'axios';

import API from '../examples/modelo_api_home.json'

const MODO_DEBUG = false; 

// Função para determinar o endpoint com base no domínio
const getApiUrl = () => {
  // Verifica se o domínio é localhost para usar o endpoint de desenvolvimento

  if(MODO_DEBUG == false){
    return process.env.REACT_APP_API_PRO;
  }

  if (window.location.hostname === 'localhost') {

     return process.env.REACT_APP_API_DEV;
  } else {
    // Para produção ou qualquer outro ambiente
    return process.env.REACT_APP_API_PRO;
  }
};

const getDominio = ()=>{
  if (window.location.hostname === 'localhost') {
      return "base10makeup" /// padrao de teste
  }
  if (window.location.hostname === 'dragon-baron.netlify.app') {
    return "base10makeup" /// padrao de teste
  }

  var  hostname = window.location.hostname;

  console.log('getHost',hostname)

  hostname = getBeforeFirstDot(hostname);
  console.log('firstHost',hostname)

  return hostname;
}

function getBeforeFirstDot(domain) {
  if (typeof domain !== "string") {
    throw new Error("O argumento deve ser uma string.");
  }

  // Remove o www. se existir
  if (domain.startsWith("www.")) {
    domain = domain.slice(4);
  }

  const index = domain.indexOf(".");
  if (index === -1) {
    return domain; // Retorna a string inteira se não houver ponto
  }

  return domain.substring(0, index);
}


const apiService = {
    
  listar: async (page) => {


    const data = JSON.stringify({
      "dominio": getDominio()
    });

    var enpoint =  getApiUrl();
    enpoint = enpoint+'/integracao/site/pagina'+page

    const config = {
      method: 'post',
      url: enpoint,
      headers: { 
        'Content-Type': 'application/json'
      },
      data: data
    };

 
    try {
      const response = await axios.request(config);
      return response.data;
    } catch (error) {
      console.log('Erro ao chamar a API:', error);
      throw error;
    }
  },

  ambiente:()=>{
    return getApiUrl()
  },

  obterDominio:()=>{
    return getDominio()
  }
};

export default apiService;
